<template>
    <!-- Componente para seleccionar el distribuidor -->
    <select
        name="subsidiaries"
        id="subsidiaries"
        class="block w-64 lg:w-60 text-center text-sm pl-1 py-2 subsidiaries border border-solid border-light-gray bg-white"
        v-model.number="subsidiary"
    >
        <option
            value=""
            disabled
            selected
        >{{ disOption }}</option>
        <optgroup
            v-for="(subsidiary, key) in subsidiaries"
            :key="key"
            :label="key"
        >
            <option
                v-for="sub in subsidiary"
                :key="sub.id"
                :value="sub"
            >{{                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 sub.name                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 }}</option>
        </optgroup>
    </select>
</template>

<script>
export default {
    props: ["redirect"],
    data() {
        return {
            url: $(".url").text(),
            // Variabnle para almacenar el distribuidor seleccionado
            subsidiary: "",
            // Variable para almacenar los distribuidores para
            // mostrarlos en el select
            subsidiaries: [],
            // Variable para almacenar los estados de los distribuidores
            // y mostrar los distribuidores ordenados por estados
            // en el select
            states: [],
            // Variable para mostrar el estatus de la carga
            // de los distribuidores en el select
            disOption: "Cargando...",
        };
    },
    watch: {
        // Observa la variable subsidiary para que cuando
        // se seleccione uno, se redireccione al distribuidor
        // correspondiente siempre que redirect venga en true
        subsidiary: function (val, oldVal) {
            if (this.redirect === "true") {
                if (val != oldVal)
                    window.location.href = this.url + "/" + val.webpage + "/";
            } else {
                this.$emit("sub-selected", val);
            }
        },
    },
    methods: {
        // Obtiene los distribuidores y los estados para cargalos en el select
        getSubsSelectData() {
            axios
                .get(this.url + "/get-subselect-data")
                .then((resp) => {
                    this.subsidiaries = resp.data.subsidiaries;
                    this.states = resp.data.states;

                    //Ordena los distribuidores de Nuevo León
                    let reorder = Object.values(
                        this.subsidiaries["Nuevo León"]
                    );
                    if (reorder.length === 5) {
                        this.moveInArray(reorder, 3, 1);
                        this.moveInArray(reorder, 3, 4);
                        this.subsidiaries["Nuevo León"] = reorder;
                    }

                    //Ordena los distribuidores de Jalisco
                    reorder = Object.values(this.subsidiaries["Jalisco"]);
                    if (reorder.length === 5) {
                        this.moveInArray(reorder, 4, 3);
                        this.subsidiaries["Jalisco"] = reorder;
                    }

                    // Cambia el texto de la opción deshabilitada del select
                    this.disOption = "- Selecciona un distribuidor -";
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // Función para mover un elemento dentro de un arrays
        moveInArray(arr, from, to) {
            // Delete the item from it's current position
            let item = arr.splice(from, 1);
            // console.log(item);
            // Move the item to its new position
            arr.splice(to, 0, item[0]);
        },
    },
    created() {
        // Obtiene los distribuidores para el select
        // en cuanto se crea el componente
        this.getSubsSelectData();
    },
};
</script>

<style>

</style>
